type Config = {
  apiURL: string,
  hotelID: string,
  apiKey: string,
  grafikiRodzaj: string,
  lang: string[],
  grafikMaxiMini: string,
  rezNr: string,
  telNr: string,
  platnoscLink: string,
  stanPlatnosci: string,
  platnosc: string,
  preautoryzacja: string,
  przerwa: string,
  przerwaTyp: string,
  hotelRezerwuj: string,
  hotelMaxIloscPokoi: string,
  payWebPrefiks: string,
  payWebKontoId: string,
  payWebPotwierdzAktywny: string,
  rodzPokoiPodstrona: string,


  hotelGrafiki : string,
  sprzedazRaporty : string,
  lokalPrzydzial : string,

  menu1PobytPokaz: string,
  menu1PobytZmien: string,
  menu1PobytAnuluj: string,
  menu1ObiektOtworz: string,
  menu1ObiektOpis1: string,
  menu1ObiektOpis2: string,
  menu1ObiektOpis3: string,
  menu1ObiektOpis4: string,
  menu1PokojOtworz: string,
  menu1PokojOpis1: string,
  menu1PokojOpis2: string,
  menu1PokojOpis3: string,
  menu1PokojOpis4: string,
  menu1PietroOtworz: string,
  menu1PietroOpis1: string,
  menu1PietroOpis2: string,
  menu1PietroOpis3: string,
  menu1PietroOpis4: string,
  menu1ParkingOtworz: string,
  menu1ParkingOpis1: string,
  menu1ParkingOpis2: string,
  menu1ParkingOpis3: string,
  menu1ParkingOpis4: string,
  menu1QrKodPobierz: string,
  menu1FakturaPobierz: string,
  
  zasady1: string,
  zasady1Opis: string,
  zasady1Link: string,
  zasady1Zaznacz: string,
  zasady2: string,
  zasady2Opis: string,
  zasady2Link: string,
  zasady2Zaznacz: string,
  zasady3: string,
  zasady3Opis: string,
  zasady3Link: string,
  zasady3Zaznacz: string,
  zasady4: string,
  zasady4Opis: string,
  zasady4Link: string,
  zasady4Zaznacz: string,

  ikonaPrzelewy24: string,
  ikonaMBank: string,
  ikonaAutoPay: string,
  ikonaPayU: string,

  hotelKiosk: string,
  hotelKioskDowodNr: string,
  hotelKioskAdres: string,
  hotelKioskImionaRodz: string,
  hotelKioskDataUr: string,
  hotelKioskMscUr: string,

  grafikUslugaRodzPok1: string,
  grafikUslugaRodzPok2: string,
  grafikUslugaRodzPok3: string,
  grafikUslugaRodzPok4: string,
  grafikUslugaRodzPok5: string,
  grafikUslugaRodzPok6: string,
  grafikUslugaRodzPok7: string,
  grafikUslugaRodzPok8: string,
  grafikUslugaRodzPok9: string,
  grafikUslugaOpisAktywny: string,
  grafikUslugaOpisOpis: string,
};

let CONFIG: Config = {
  apiURL: 'http://test.vsc24.eu:8080/vscHotelBook',
  hotelID: 'Toshiba',
  apiKey: '12349',
  grafikiRodzaj: "0",
  lang: ['en', 'pl', 'de', 'sk'],
  grafikMaxiMini: '1',
  rezNr: "",
  telNr: "",
  platnoscLink: "1",
  stanPlatnosci: "",
  platnosc : '0', 
  preautoryzacja : '0',
  przerwa: "0", 
  przerwaTyp: "0",
  hotelRezerwuj: "1",
  hotelMaxIloscPokoi: "1",
  payWebPrefiks: "room",
  payWebKontoId: "1",
  payWebPotwierdzAktywny: "1",

  hotelGrafiki : '1',
  sprzedazRaporty : '1',
  lokalPrzydzial : '',

  menu1PobytPokaz: "0",
  menu1PobytZmien: "0",
  menu1PobytAnuluj: "0",
  menu1ObiektOtworz: "0",
  menu1ObiektOpis1: "",
  menu1ObiektOpis2: "",
  menu1ObiektOpis3: "",
  menu1ObiektOpis4: "",
  menu1PokojOtworz: "0",
  menu1PokojOpis1: "",
  menu1PokojOpis2: "",
  menu1PokojOpis3: "",
  menu1PokojOpis4: "",
  menu1PietroOtworz: "0",
  menu1PietroOpis1: "",
  menu1PietroOpis2: "",
  menu1PietroOpis3: "",
  menu1PietroOpis4: "",
  menu1ParkingOtworz: "0",
  menu1ParkingOpis1: "",
  menu1ParkingOpis2: "",
  menu1ParkingOpis3: "",
  menu1ParkingOpis4: "",
  menu1QrKodPobierz: "0",
  menu1FakturaPobierz: "0",

  zasady1: "0",
  zasady1Opis: "",
  zasady1Link: "",
  zasady1Zaznacz: "0",
  zasady2: "0",
  zasady2Opis: "",
  zasady2Link: "",
  zasady2Zaznacz: "0",
  zasady3: "0",
  zasady3Opis: "",
  zasady3Link: "",
  zasady3Zaznacz: "0",
  zasady4: "0",
  zasady4Opis: "",
  zasady4Link: "",
  zasady4Zaznacz: "0",

  ikonaPrzelewy24: "",
  ikonaMBank: "",
  ikonaAutoPay: "",
  ikonaPayU: "",

  hotelKiosk: '0',
  hotelKioskDowodNr: '0',
  hotelKioskAdres: '0',
  hotelKioskImionaRodz: '0',
  hotelKioskDataUr: '0',
  hotelKioskMscUr: '0', 

  grafikUslugaRodzPok1: '',
  grafikUslugaRodzPok2: '',
  grafikUslugaRodzPok3: '',
  grafikUslugaRodzPok4: '',
  grafikUslugaRodzPok5: '',
  grafikUslugaRodzPok6: '',
  grafikUslugaRodzPok7: '',
  grafikUslugaRodzPok8: '',
  grafikUslugaRodzPok9: '',
  grafikUslugaOpisAktywny: '0',
  grafikUslugaOpisOpis: 'rower'
};

// npm install typings --global
// https://stackoverflow.com/questions/50488121/typescript-add-functions-to-window-with-d-ts-file

interface WindowInterface extends Window {
  config: Config;
}

let window2config = () => { // uruchamiane w App : render()
  var config: Config = (window as unknown as WindowInterface).config || {
    // gdy nie ma public/config.js, ustawiam na parametry z kompilacji - def. wyżej
    apiUrl: CONFIG.apiURL,
    hotelID: CONFIG.hotelID,
    apiKey: CONFIG.apiKey,
    grafikiRodzaj: CONFIG.grafikiRodzaj,
    lang: CONFIG.lang,
    grafikMaxiMini: CONFIG.grafikMaxiMini,
    rezNr: CONFIG.rezNr,
    telNr: CONFIG.telNr,
    platnoscLink: CONFIG.platnoscLink,
    stanPlatnosci: CONFIG.stanPlatnosci,
    platnosc: CONFIG.platnosc,
    preautoryzacja: CONFIG.preautoryzacja,
    przerwa: CONFIG.przerwa,
    przerwaTyp: CONFIG.przerwaTyp,
    hotelRezerwuj: CONFIG.hotelRezerwuj,
    hotelMaxIloscPokoi: CONFIG.hotelMaxIloscPokoi,
    payWebPrefiks: CONFIG.payWebPrefiks,
    payWebKontoId: CONFIG.payWebKontoId,
    payWebPotwierdzAktywny: CONFIG.payWebPotwierdzAktywny,
    rodzPokoiPodstrona: CONFIG.rodzPokoiPodstrona,

    hotelGrafiki : CONFIG.hotelGrafiki,
    sprzedazRaporty : CONFIG.sprzedazRaporty,
    lokalPrzydzial : CONFIG.lokalPrzydzial,

    menu1PobytPokaz: CONFIG.menu1PobytPokaz,
    menu1PobytZmien: CONFIG.menu1PobytZmien,
    menu1PobytAnuluj: CONFIG.menu1PobytAnuluj,
    menu1ObiektOtworz: CONFIG.menu1ObiektOtworz,
    menu1PokojOtworz: CONFIG.menu1PokojOtworz,
    menu1PietroOtworz: CONFIG.menu1PietroOtworz,
    menu1ParkingOtworz: CONFIG.menu1ParkingOtworz,
    menu1QrKodPobierz: CONFIG.menu1QrKodPobierz,
    menu1FakturaPobierz: CONFIG.menu1FakturaPobierz,

    zasady1: CONFIG.zasady1,
    zasady1Opis: CONFIG.zasady1Opis,
    zasady1Link: CONFIG.zasady1Link,
    zasady1Zaznacz: CONFIG.zasady1Zaznacz,
    zasady2: CONFIG.zasady2,
    zasady2Opis: CONFIG.zasady2Opis,
    zasady2Link: CONFIG.zasady2Link,
    zasady2Zaznacz: CONFIG.zasady2Zaznacz,
    zasady3: CONFIG.zasady3,
    zasady3Opis: CONFIG.zasady3Opis,
    zasady3Link: CONFIG.zasady3Link,
    zasady3Zaznacz: CONFIG.zasady3Zaznacz,
    zasady4: CONFIG.zasady4,
    zasady4Opis: CONFIG.zasady4Opis,
    zasady4Link: CONFIG.zasady4Link,
    zasady4Zaznacz: CONFIG.zasady4Zaznacz,

    ikonaPrzelewy24: CONFIG.ikonaPrzelewy24,
    ikonaMBank: CONFIG.ikonaMBank,
    ikonaAutoPay: CONFIG.ikonaAutoPay,
    ikonaPayU: CONFIG.ikonaPayU,

    hotelKiosk: CONFIG.hotelKiosk,
    hotelKioskDowodNr: CONFIG.hotelKioskDowodNr,
    hotelKioskAdres: CONFIG.hotelKioskAdres,
    hotelKioskImionaRodz: CONFIG.hotelKioskImionaRodz,
    hotelKioskDataUr: CONFIG.hotelKioskDataUr,
    hotelKioskMscUr: CONFIG.hotelKioskMscUr,

    grafikUslugaRodzPok1: CONFIG.grafikUslugaRodzPok1,
    grafikUslugaRodzPok2: CONFIG.grafikUslugaRodzPok2,
    grafikUslugaRodzPok3: CONFIG.grafikUslugaRodzPok3,
    grafikUslugaRodzPok4: CONFIG.grafikUslugaRodzPok4,
    grafikUslugaRodzPok5: CONFIG.grafikUslugaRodzPok5,
    grafikUslugaRodzPok6: CONFIG.grafikUslugaRodzPok6,
    grafikUslugaRodzPok7: CONFIG.grafikUslugaRodzPok7,
    grafikUslugaRodzPok8: CONFIG.grafikUslugaRodzPok8,
    grafikUslugaRodzPok9: CONFIG.grafikUslugaRodzPok9,
    grafikUslugaOpisAktywny: CONFIG.grafikUslugaOpisAktywny,
    grafikUslugaOpisOpis: CONFIG.grafikUslugaOpisOpis,
  }
  CONFIG.apiURL = config.apiURL;
  CONFIG.hotelID = config.hotelID;
  CONFIG.apiKey = config.apiKey;
  CONFIG.grafikiRodzaj = config.grafikiRodzaj ? config.grafikiRodzaj : "0";
  CONFIG.lang = config.lang;
  CONFIG.grafikMaxiMini = config.grafikMaxiMini ? config.grafikMaxiMini : "1";
  CONFIG.rezNr = config.rezNr ? config.rezNr : "";
  CONFIG.telNr = config.telNr ? config.telNr : "";
  CONFIG.platnoscLink = config.platnoscLink ? config.platnoscLink : "1";
  CONFIG.stanPlatnosci = config.stanPlatnosci ? config.stanPlatnosci : "";
  CONFIG.platnosc = config.platnosc ? config.platnosc : "0";
  CONFIG.preautoryzacja = config.preautoryzacja ? config.preautoryzacja : "0";
  CONFIG.przerwa = config.przerwa ? config.przerwa : "0";
  CONFIG.przerwaTyp = config.przerwaTyp ? config.przerwaTyp : "0";
  CONFIG.hotelRezerwuj = config.hotelRezerwuj ? config.hotelRezerwuj : "1";
  CONFIG.hotelMaxIloscPokoi = config.hotelMaxIloscPokoi ? config.hotelMaxIloscPokoi : "1";
  CONFIG.payWebPrefiks = config.payWebPrefiks ? config.payWebPrefiks : "room";
  CONFIG.payWebKontoId = config.payWebKontoId ? config.payWebKontoId : "1";
  CONFIG.payWebPotwierdzAktywny = config.payWebPotwierdzAktywny ? config.payWebPotwierdzAktywny : "1";
  CONFIG.rodzPokoiPodstrona = config.rodzPokoiPodstrona ? config.rodzPokoiPodstrona : "0";

  CONFIG.hotelGrafiki = config.hotelGrafiki ? config.hotelGrafiki : "1";
  CONFIG.sprzedazRaporty = config.sprzedazRaporty ? config.sprzedazRaporty : "1" ;
  CONFIG.lokalPrzydzial = config.lokalPrzydzial ? config.lokalPrzydzial : "" ;

  CONFIG.menu1PobytPokaz = config.menu1PobytPokaz ? config.menu1PobytPokaz : "0";
  CONFIG.menu1PobytZmien = config.menu1PobytZmien ? config.menu1PobytZmien : "0";
  CONFIG.menu1PobytAnuluj = config.menu1PobytAnuluj ? config.menu1PobytAnuluj : "0";
  CONFIG.menu1ObiektOtworz = config.menu1ObiektOtworz ? config.menu1ObiektOtworz : "0";
  CONFIG.menu1ObiektOpis1 = config.menu1ObiektOpis1 ? config.menu1ObiektOpis1 : "";
  CONFIG.menu1ObiektOpis2 = config.menu1ObiektOpis2 ? config.menu1ObiektOpis2 : "";
  CONFIG.menu1ObiektOpis3 = config.menu1ObiektOpis3 ? config.menu1ObiektOpis3 : "";
  CONFIG.menu1ObiektOpis4 = config.menu1ObiektOpis4 ? config.menu1ObiektOpis4 : "";
  CONFIG.menu1PokojOtworz = config.menu1PokojOtworz ? config.menu1PokojOtworz : "0";
  CONFIG.menu1PokojOpis1 = config.menu1PokojOpis1 ? config.menu1PokojOpis1 : "";
  CONFIG.menu1PokojOpis2 = config.menu1PokojOpis2 ? config.menu1PokojOpis2 : "";
  CONFIG.menu1PokojOpis3 = config.menu1PokojOpis3 ? config.menu1PokojOpis3 : "";
  CONFIG.menu1PokojOpis4 = config.menu1PokojOpis4 ? config.menu1PokojOpis4 : "";
  CONFIG.menu1PietroOtworz = config.menu1PietroOtworz ? config.menu1PietroOtworz : "0";
  CONFIG.menu1PietroOpis1 = config.menu1PietroOpis1 ? config.menu1PietroOpis1 : "";
  CONFIG.menu1PietroOpis2 = config.menu1PietroOpis2 ? config.menu1PietroOpis2 : "";
  CONFIG.menu1PietroOpis3 = config.menu1PietroOpis3 ? config.menu1PietroOpis3 : "";
  CONFIG.menu1PietroOpis4 = config.menu1PietroOpis4 ? config.menu1PietroOpis4 : "";
  CONFIG.menu1ParkingOtworz = config.menu1ParkingOtworz ? config.menu1ParkingOtworz : "0";
  CONFIG.menu1ParkingOpis1 = config.menu1ParkingOpis1 ? config.menu1ParkingOpis1 : "";
  CONFIG.menu1ParkingOpis2 = config.menu1ParkingOpis2 ? config.menu1ParkingOpis2 : "";
  CONFIG.menu1ParkingOpis3 = config.menu1ParkingOpis3 ? config.menu1ParkingOpis3 : "";
  CONFIG.menu1ParkingOpis4 = config.menu1ParkingOpis4 ? config.menu1ParkingOpis4 : "";
  CONFIG.menu1QrKodPobierz = config.menu1QrKodPobierz ? config.menu1QrKodPobierz : "0";
  CONFIG.menu1FakturaPobierz = config.menu1FakturaPobierz ? config.menu1FakturaPobierz : "0";

  CONFIG.zasady1 = config.zasady1 ? config.zasady1 : "0";
  CONFIG.zasady1Opis = config.zasady1Opis ? config.zasady1Opis : "";
  CONFIG.zasady1Link = config.zasady1Link ? config.zasady1Link : "";
  CONFIG.zasady1Zaznacz = config.zasady1Zaznacz ? config.zasady1Zaznacz : "0";
  CONFIG.zasady2 = config.zasady2 ? config.zasady2 : "0";
  CONFIG.zasady2Opis = config.zasady2Opis ? config.zasady2Opis : "";
  CONFIG.zasady2Link = config.zasady2Link ? config.zasady2Link : "";
  CONFIG.zasady2Zaznacz = config.zasady2Zaznacz ? config.zasady2Zaznacz : "0";
  CONFIG.zasady3 = config.zasady3 ? config.zasady3 : "0";
  CONFIG.zasady3Opis = config.zasady3Opis ? config.zasady3Opis : "";
  CONFIG.zasady3Link = config.zasady3Link ? config.zasady3Link : "";
  CONFIG.zasady3Zaznacz = config.zasady3Zaznacz ? config.zasady3Zaznacz : "0";  
  CONFIG.zasady4 = config.zasady4 ? config.zasady4 : "0";
  CONFIG.zasady4Opis = config.zasady4Opis ? config.zasady4Opis : "";
  CONFIG.zasady4Link = config.zasady4Link ? config.zasady4Link : "";
  CONFIG.zasady4Zaznacz = config.zasady4Zaznacz ? config.zasady4Zaznacz : "0";


  CONFIG.ikonaPrzelewy24 = config.ikonaPrzelewy24 ? config.ikonaPrzelewy24 : "0";
  CONFIG.ikonaMBank = config.ikonaMBank ? config.ikonaMBank : "0";
  CONFIG.ikonaAutoPay = config.ikonaAutoPay ? config.ikonaAutoPay : "0";
  CONFIG.ikonaPayU = config.ikonaPayU ? config.ikonaPayU : "0";

  CONFIG.hotelKiosk = config.hotelKiosk ? config.hotelKiosk : "0";
  CONFIG.hotelKioskDowodNr = config.hotelKioskDowodNr ? config.hotelKioskDowodNr : "0";
  CONFIG.hotelKioskAdres = config.hotelKioskAdres ? config.hotelKioskAdres : "0";
  CONFIG.hotelKioskImionaRodz = config.hotelKioskImionaRodz ? config.hotelKioskImionaRodz : "0";
  CONFIG.hotelKioskDataUr = config.hotelKioskDataUr ? config.hotelKioskDataUr : "0";
  CONFIG.hotelKioskMscUr = config.hotelKioskMscUr ? config.hotelKioskMscUr : "0";

  CONFIG.grafikUslugaRodzPok1 = config.grafikUslugaRodzPok1 ? config.grafikUslugaRodzPok1 : "";
  CONFIG.grafikUslugaRodzPok2 = config.grafikUslugaRodzPok2 ? config.grafikUslugaRodzPok2 : "";
  CONFIG.grafikUslugaRodzPok3 = config.grafikUslugaRodzPok3 ? config.grafikUslugaRodzPok3 : "";
  CONFIG.grafikUslugaRodzPok4 = config.grafikUslugaRodzPok4 ? config.grafikUslugaRodzPok4 : "";
  CONFIG.grafikUslugaRodzPok5 = config.grafikUslugaRodzPok5 ? config.grafikUslugaRodzPok5 : "";
  CONFIG.grafikUslugaRodzPok6 = config.grafikUslugaRodzPok6 ? config.grafikUslugaRodzPok6 : "";
  CONFIG.grafikUslugaRodzPok7 = config.grafikUslugaRodzPok7 ? config.grafikUslugaRodzPok7 : "";
  CONFIG.grafikUslugaRodzPok8 = config.grafikUslugaRodzPok8 ? config.grafikUslugaRodzPok8 : "";
  CONFIG.grafikUslugaRodzPok9 = config.grafikUslugaRodzPok9 ? config.grafikUslugaRodzPok9 : "";
  CONFIG.grafikUslugaOpisAktywny = config.grafikUslugaOpisAktywny ? config.grafikUslugaOpisAktywny : "0";
  CONFIG.grafikUslugaOpisOpis = config.grafikUslugaOpisOpis ? config.grafikUslugaOpisOpis : "";
  
}

export { window2config }
export default CONFIG;
